// extracted by mini-css-extract-plugin
export default {"menuItemIcon":"driversTable_menuItemIcon__rTIOz"};